import {hookToAttributeSelector} from '@wix/panda-js-utils'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {Text, TextTypography} from 'wix-ui-tpa/cssVars'
import c from '../classnames.scss'
import {BackToSiteLink} from '../common/back-to-site-link'
import {FormButton} from '../form-button'
import s from './change-rsvp.scss'
import {ChangeRsvpProps} from './index'

export const ChangeRsvp: React.FC<ChangeRsvpProps> = ({
  rsvpStatusMessageTranslation,
  rsvpStatusButtonTextTranslation,
  t,
  changeMemberRsvp,
}) => {
  const containerClass = classNames(c.formBackgroundColor)

  return (
    <div className={containerClass}>
      <div className={s.editRsvpMessages}>
        <div className={classNames(s.editRsvpTitle, c.formTitleFont, c.formTitleColor)}>
          {t(rsvpStatusMessageTranslation)}
        </div>
        <FormButton
          text={t(rsvpStatusButtonTextTranslation)}
          width="auto"
          onClick={() => changeMemberRsvp(hookToAttributeSelector(DH.RSVP_BUTTON))}
          dataHook={DH.RSVP_BUTTON}
        />
        <BackToSiteLink className={s.back}>
          <Text typography={TextTypography.listText}>{t('members.updateRsvp.link')}</Text>
        </BackToSiteLink>
      </div>
    </div>
  )
}
